<template>
  <div id="new-info-item">
    <PageTitle
      v-if="id==''"
      title="Informatie toevoegen"
      description="Per item kan er een hyperlink worden toegevoegd. In de app wordt dit een 'button' waarin de tekst staat die hieronder bij label is ingevoerd."
    ></PageTitle>
    <PageTitle
      v-if="id!=''"
      title="Informatie aanpassen"
      description="Als er een afbeelding is gekoppeld is deze hieronder zichtbaar. Wanneer je een nieuwe afbeelding kiest wordt de oude verwijderd."
    ></PageTitle>

    <form @submit.prevent>
      <div class="form-group float-right">
        <button @click="cancel" class="btn btn-light mr-2">Annuleren</button>
        <button @click="saveItem(false)" class="btn btn-warning mr-2">Opslaan als concept</button>
        <button @click="saveItem(true)" class="btn btn-success">Opslaan en publiceren</button>
      </div>
      <Storage
        path="information/"
        :initialPic="initialPic"
        v-on:setUrl="setUrl"
        v-on:setFilename="setFilename"
        imageOnly
      ></Storage>
      <div class="form-group">
        <label for="title">Titel</label>
        <input type="text" class="form-control" placeholder="Titel" v-model="title" />
      </div>
      <div class="form-group">
        <label for="type">Type of categorie</label>
        <input type="text" class="form-control" placeholder="nieuws" v-model="type" />
      </div>
      <div class="form-group">
        <label for="section">Bericht</label>
        <textarea class="form-control" id="section" v-model="content" rows="5"></textarea>
      </div>
      <div class="form-group">
        <label for="type">Knop met hyperlink toevoegen</label>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon3">https://</span>
          </div>
          <input type="text" class="form-control" placeholder="url" v-model="actionUrl" />
          <input type="text" class="form-control" placeholder="label" v-model="actionLabel" />
        </div>
      </div>
      <Selectoptions
        v-on:setOptions="setOptions"
        :checkedEstablishments="checkedEstablishments"
        :checkedPositions="checkedPositions"
      ></Selectoptions>
    </form>
  </div>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import PageTitle from "@/components/PageTitle.vue";
import Storage from "@/components/Storage.vue";
import Selectoptions from "@/components/Selectoptions.vue";
var firestorage = fb.firestorage;

export default {
  name: "new-info-item",
  components: {
    PageTitle,
    Storage,
    Selectoptions
  },
  data() {
    return {
      id: "",
      title: "",
      type: "nieuws",
      content: "",
      actionLabel: "",
      actionUrl: "",
      checkedEstablishments: [],
      checkedPositions: [],
      downloadURL: "",
      fileName: "",
      initialPic: ""
    };
  },
  methods: {
    setOptions(data) {
      // emit from selectoptions
      this.checkedPositions = data.checkedPositions;
      this.checkedEstablishments = data.checkedEstablishments;
    },
    setUrl(url) {
      this.downloadURL = url;
    },
    setFilename(fn) {
      this.fileName = fn;
    },
    /*
    for now you can only add 1 image. The db structure is prepared to add more. TODO
    */
    saveItem(live) {
      var now = new Date();
      if (this.id == "") {
        fb.companiesCollection
          .doc(this.$cookies.get("company"))
          .collection("information")
          .add({
            can_comment: false,
            date_created: now.toISOString(),
            created_by: this.$cookies.get("user"),
            sections: [
              {
                title: this.title,
                content: this.content,
                order: 1,
                actionLabel: this.actionLabel,
                actionUrl: this.actionUrl
              }
            ],
            status: live ? "live" : "concept",
            type: this.type,
            images: [{ url: this.downloadURL, filename: this.fileName }],
            establishments:
              this.checkedEstablishments.length > 0
                ? this.checkedEstablishments
                : null,
            positions:
              this.checkedPositions.length > 0 ? this.checkedPositions : null
          })
          .then(docRef => {
            // also add a notification to trigger the firebase functions
            if (live) this.addNotification(docRef.id);
            console.log(docRef.id);
            this.$router.push("/news");
          })
          .catch(error => console.log(error));
      } else {
        var docId = this.id;
        fb.companiesCollection
          .doc(this.$cookies.get("company"))
          .collection("information")
          .doc(docId)
          .update({
            can_comment: false,
            date_updated: now.toISOString(),
            updated_by: this.$cookies.get("user"),
            sections: [
              {
                title: this.title,
                content: this.content,
                order: 1,
                actionLabel: this.actionLabel,
                actionUrl: this.actionUrl
              }
            ],
            status: live ? "live" : "concept",
            type: this.type,
            images: [
              {
                url: this.downloadURL != "" ? this.downloadURL : this.url,
                filename: this.fileName
              }
            ],
            establishments:
              this.checkedEstablishments &&
              this.checkedEstablishments.length > 0
                ? this.checkedEstablishments
                : null,
            positions:
              this.checkedPositions && this.checkedPositions.length > 0
                ? this.checkedPositions
                : null
          })
          .then(() => {
            if (live) this.addNotification(docId);
            this.$router.push("/news");
          })
          .catch(error => console.log(error));
      }
    },
    addNotification(docId) {
      /*
        adds a notification to fbase when published
        this will trigger a firebase function to send a push notification to effected users
        */

      this.$confirm({
        message: `Wil je nu een automatische pushnotificatie sturen?`,
        button: {
          no: "overslaan",
          yes: "verzenden"
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: confirm => {
          var now = new Date();
          fb.notificationsCollection
            .add({
              type: "news",
              refid: docId,
              date: now,
              created_by: this.$cookies.get("user"),
              title: this.title,
              message:
                "Er is een nieuw bericht gepubliceerd. Je vindt dit in nieuws.",
              establishments:
                this.checkedEstablishments.length > 0
                  ? this.checkedEstablishments
                  : null,
              positions:
                this.checkedPositions.length > 0 ? this.checkedPositions : null,
              hidden: true,
              company: this.$cookies.get("company"),
              sendPush: confirm
            })
            .catch(error => console.log(error));
        }
      });
    },
    cancel() {
      // afbeelding? weggooien als het een nieuw item betreft
      if (this.downloadURL != "" && this.id == "new") {
        firestorage
          .ref(
            "information/" + this.$cookies.get("company") + "/" + this.fileName
          )
          .delete()
          .then(() => {
            this.$router.go(-1);
          })
          .catch(error => {
            console.error(`file delete error occured: ${error}`);
          });
      } else {
        this.$router.go(-1);
      }
    }
  },

  beforeRouteEnter(to, from, next) {
    if (to.params.id && to.params.id != "new") {
      fb.companiesCollection
        .doc(window.$cookies.get("company"))
        .collection("information")
        .doc(to.params.id)
        .get()
        .then(doc => {
          console.log(doc.data());
          next(vm => {
            vm.id = doc.id;
            vm.type = doc.data().type;
            vm.title = doc.data().sections[0].title;
            vm.content = doc.data().sections[0].content;
            vm.actionUrl = doc.data().sections[0].actionUrl ?? "";
            vm.actionLabel = doc.data().sections[0].actionLabel ?? "";
            if (doc.data().establishments != null)
              vm.checkedEstablishments = doc.data().establishments;
            if (doc.data().positions != null)
              vm.checkedPositions = doc.data().positions;
            vm.downloadURL = doc.data().images[0].url ?? "";
            vm.initialPic = doc.data().images[0].url ?? "";
            vm.fileName = doc.data().images[0].filename ?? "";
          });
        });
    } else {
      next();
    }
  }
};
</script>